import { memo, ReactNode } from 'react';
import ContextualLink from '@/components/seo/ContextualLink';

interface SeoContentSection {
  title: string;
  content: (string | ReactNode)[];
}

interface SeoRichContentProps {
  page: 'home' | 'evenements' | 'professionnels' | 'catalogue' | 'contact' | 'about' | 'devis';
}

const contentData: Record<string, SeoContentSection[]> = {
  home: [
    {
      title: "Agence évènementielle de luxe à Paris et en Île-de-France",
      content: [
        "home_p1",
        "home_p2"
      ]
    },
    {
      title: "Privatisation exclusive et direction artistique sur-mesure",
      content: [
        "Nous proposons une gamme complète de services haut de gamme : direction artistique, scénographie sur-mesure, privatisation exclusive de lieux d'exception, coordination haute performance le jour J et sélection de prestataires d'élite. Chaque élément est pensé pour créer une atmosphère de prestige unique et mémorable.",
        "Notre réseau confidentiel de partenaires triés sur le volet garantit une qualité irréprochable. Photographes, artistes floraux, traiteurs gastronomiques : tous partagent notre exigence d'excellence et notre passion pour l'évènementiel de luxe à Paris."
      ]
    },
    {
      title: "Pourquoi confier son évènement à une agence de luxe ?",
      content: [
        "Faire appel à une agence évènementielle de luxe comme Maison Eridia, c'est s'assurer une célébration d'exception orchestrée avec une précision haute performance. Nous prenons en charge la privatisation des lieux, la direction artistique, la coordination logistique et la gestion des imprévus avec une confidentialité absolue.",
        "home_p6"
      ]
    }
  ],
  evenements: [
    {
      title: "Wedding planner luxe Paris et célébrations privées prestige",
      content: [
        "evenements_p1",
        "Chaque célébration est une création sur-mesure où privatisation exclusive, scénographie d'exception et confidentialité absolue sont au cœur de notre engagement. Vous profitez pleinement de votre évènement pendant que notre équipe orchestre chaque détail avec une précision haute performance."
      ]
    },
    {
      title: "Une expertise luxe reconnue à Paris et en Île-de-France",
      content: [
        "Fort de notre expertise dans l'hôtellerie de luxe et l'évènementiel prestige, nous intervenons dans les lieux d'exception de Paris et d'Île-de-France. Que ce soit dans un domaine privatisé, un palais parisien ou un château en région, nous déployons une scénographie sur-mesure pour créer une ambiance de prestige inoubliable.",
        "Notre connaissance approfondie des adresses confidentielles et des prestataires d'élite de la région parisienne garantit une organisation fluide et un résultat à la hauteur de vos exigences les plus élevées."
      ]
    }
  ],
  professionnels: [
    {
      title: "Agence évènementielle luxe Paris : séminaires prestige et soirées d'entreprise haut de gamme",
      content: [
        "pro_p1",
        "Notre approche B2B allie direction artistique et haute performance pour concevoir des évènements professionnels qui impressionnent vos clients, motivent vos équipes et renforcent votre image de marque. Privatisation exclusive et confidentialité absolue sont au cœur de chaque projet."
      ]
    },
    {
      title: "Privatisation exclusive et scénographie corporate à Paris et Île-de-France",
      content: [
        "Nous prenons en charge l'intégralité de votre évènement professionnel de prestige : privatisation exclusive de lieux d'exception à Paris, direction artistique corporate, scénographie sur-mesure, coordination haute performance et sélection de prestataires d'élite. Vous vous concentrez sur vos invités pendant que notre équipe assure la perfection de chaque instant.",
        "Nos formules haut de gamme s'adaptent à toutes les envergures : du séminaire prestige de 20 personnes au gala corporate de 500 convives en Île-de-France. Nous garantissons une qualité irréprochable et un service d'exception."
      ]
    }
  ],
  catalogue: [
    {
      title: "Location de matériel évènementiel en Île-de-France",
      content: [
        "Notre catalogue propose une large sélection de matériel professionnel pour tous types d'évènements : mobilier (tables, chaises, mange-debout), décoration (arches florales, photobooth, guirlandes lumineuses), vaisselle (assiettes, verres, couverts haut de gamme), sonorisation et éclairage.",
        "Tout notre équipement est régulièrement renouvelé et entretenu pour garantir une qualité impeccable. Nous livrons, installons et récupérons le matériel selon vos disponibilités pour vous offrir un service sans contrainte."
      ]
    },
    {
      title: "Des équipements pour toutes les occasions",
      content: [
        "Que vous organisiez un mariage champêtre, une soirée d'entreprise élégante, un anniversaire coloré ou un cocktail raffiné, notre catalogue s'adapte à votre thème et à votre budget. Nos conseillers vous accompagnent dans le choix des équipements les plus adaptés à votre évènement.",
        "Nous proposons également des forfaits complets incluant tout le nécessaire pour votre réception : mobilier, vaisselle, décoration et éclairage. Une solution pratique pour simplifier votre organisation."
      ]
    }
  ],
  contact: [
    {
      title: "Contactez votre agence évènementielle à Paris",
      content: [
        "Notre équipe se tient à votre disposition pour répondre à toutes vos questions et vous accompagner dans la préparation de votre évènement. Que vous ayez déjà une idée précise ou que vous souhaitiez être guidé, nous prenons le temps d'échanger avec vous pour comprendre vos attentes.",
        "Nous vous répondons sous 24h ouvrées et vous proposons un rendez-vous téléphonique ou en visio pour approfondir votre projet. Cette première prise de contact est gratuite et sans engagement."
      ]
    },
    {
      title: "Une réactivité et une disponibilité exemplaires",
      content: [
        "Basés en Île-de-France, nous intervenons rapidement sur Paris et toute la région parisienne. Notre proximité nous permet d'être réactifs et présents à chaque étape de votre évènement, de la conception à la réalisation.",
        "N'hésitez pas à nous solliciter pour un devis personnalisé, un conseil ou simplement pour discuter de vos idées. L'organisation d'un évènement réussi commence par une bonne communication !"
      ]
    }
  ],
  about: [
    {
      title: "L'excellence évènementielle au service de vos célébrations",
      content: [
        "Maison Eridia est née de la volonté de rendre l'évènementiel haut de gamme accessible à tous. Notre fondatrice, forte d'une expérience dans l'hôtellerie de luxe et la coordination évènementielle, a créé une agence qui allie créativité, professionnalisme et chaleur humaine.",
        "Nous croyons que chaque célébration mérite une attention particulière et que le luxe réside dans les détails. Notre approche personnalisée nous permet de créer des évènements qui vous ressemblent, tout en respectant votre budget."
      ]
    },
    {
      title: "Une équipe passionnée et expérimentée",
      content: [
        "Notre équipe réunit des experts en scénographie, coordination, décoration et logistique évènementielle. Chacun apporte son savoir-faire et sa créativité pour transformer vos envies en réalité.",
        "Nous cultivons des relations de confiance avec nos partenaires (traiteurs, fleuristes, photographes, DJ) pour vous garantir des prestations de qualité constante. Ensemble, nous créons des moments inoubliables."
      ]
    }
  ],
  devis: [
    {
      title: "Demandez votre devis personnalisé",
      content: [
        "Notre formulaire de devis en ligne vous permet d'obtenir rapidement une estimation pour votre évènement. Indiquez-nous la date, le type de célébration, le nombre d'invités et vos envies, et nous vous proposerons une formule adaptée à votre budget.",
        "Chaque devis est élaboré sur-mesure en fonction de vos besoins spécifiques. Nous prenons en compte tous vos souhaits pour créer une proposition cohérente qui respecte votre budget et vos attentes."
      ]
    },
    {
      title: "Un accompagnement de A à Z",
      content: [
        "Au-delà du simple devis, nous vous accompagnons tout au long de votre projet. De la première prise de contact à la réalisation de votre évènement, notre équipe reste à votre écoute pour ajuster, conseiller et coordonner.",
        "Notre transparence tarifaire et notre réactivité vous permettent de prendre des décisions éclairées. Aucun frais caché, une communication claire et des délais respectés : tels sont nos engagements."
      ]
    }
  ]
};

// Paragraphs with contextual links (JSX)
const richParagraphs: Record<string, ReactNode> = {
  home_p1: (
    <p className="text-[#55626f] leading-relaxed text-justify">
      Maison Eridia est une agence évènementielle de luxe spécialisée dans la direction artistique et la scénographie d'évènements d'exception à Paris et en Île-de-France. <ContextualLink to="/univers-particuliers/mariage-prestige">Wedding planner de luxe à Paris</ContextualLink>, organisation de séminaires prestige, soirées d'entreprise haut de gamme : nous mettons notre expertise au service de célébrations sur-mesure où privatisation exclusive et confidentialité sont la norme.
    </p>
  ),
  home_p2: (
    <p className="text-[#55626f] leading-relaxed text-justify">
      Notre approche haute couture évènementielle nous permet de concevoir chaque prestation comme une œuvre unique. Du mariage prestige à l'anniversaire signature, du séminaire prestige Paris au cocktail de lancement, <ContextualLink to="/evenement-entreprise-prestige">notre agence évènementielle pour entreprises à Paris</ContextualLink> orchestre l'intégralité de votre évènement avec une exigence de luxe et une créativité sans compromis.
    </p>
  ),
  home_p6: (
    <p className="text-[#55626f] leading-relaxed text-justify">
      Que vous souhaitiez un <ContextualLink to="/univers-particuliers/mariage-prestige">wedding planner de luxe à Paris</ContextualLink> pour votre mariage prestige, un organisateur d'anniversaire signature ou un séminaire prestige en Île-de-France, notre équipe transforme votre vision en une expérience inoubliable. Chaque détail compte : de la scénographie sur-mesure au timing parfait de votre soirée.
    </p>
  ),
  evenements_p1: (
    <p className="text-[#55626f] leading-relaxed text-justify">
      <ContextualLink to="/univers-particuliers/mariage-prestige">Wedding planner de luxe à Paris</ContextualLink>, organisateur d'anniversaire prestige en Île-de-France, demande en mariage sur-mesure : Maison Eridia est l'agence évènementielle de luxe qui transforme vos célébrations privées en expériences d'exception. Notre direction artistique conçoit pour vous des évènements uniques empreints de haute couture évènementielle.
    </p>
  ),
  pro_p1: (
    <p className="text-[#55626f] leading-relaxed text-justify">
      Maison Eridia, agence évènementielle de luxe à Paris, accompagne les entreprises avec une direction artistique corporate et une scénographie sur-mesure autour de 4 pôles d'expertise : <ContextualLink to="/professionnels/evenements/seminaire-team-building-prestige">organisation de séminaires sur-mesure en Île-de-France</ContextualLink> (journées d'intégration, formations, cohésion d'équipe), Conférences & Évènements Clients, <ContextualLink to="/professionnels/evenements/soiree-entreprise-paris">conception de soirées d'entreprise de prestige</ContextualLink> (afterworks premium, célébrations internes), et Évènementiel Créateur Digital (meet-ups, lancements de projets). Bien plus qu'un simple prestataire, nous sommes une agence de conseil et de conception globale.
    </p>
  ),
};

export const SeoRichContent = memo(({ page }: SeoRichContentProps) => {
  const sections = contentData[page] || [];

  if (sections.length === 0) return null;

  return (
    <section className="relative bg-[#f8f9fa] py-16 overflow-hidden border-t border-b border-divider">
      {/* Déco radiale subtile */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(243,154,162,0.03),transparent_50%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 max-w-6xl relative">
        <div className="space-y-12">
          {sections.map((section, index) => (
            <div key={index} className="space-y-6">
              <h2 className="font-playfair text-2xl md:text-3xl font-normal text-[#0a2540]">
                {section.title}
              </h2>
              <div className="space-y-4">
                {section.content.map((paragraph, pIndex) => {
                  // Check if it's a key to a rich paragraph with links
                  if (typeof paragraph === 'string' && richParagraphs[paragraph]) {
                    return <div key={pIndex}>{richParagraphs[paragraph]}</div>;
                  }
                  // Regular string paragraph
                  if (typeof paragraph === 'string') {
                    return (
                      <p key={pIndex} className="text-[#55626f] leading-relaxed text-justify">
                        {paragraph}
                      </p>
                    );
                  }
                  // ReactNode
                  return <div key={pIndex}>{paragraph}</div>;
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

SeoRichContent.displayName = 'SeoRichContent';
